import React, { Component } from 'react';
import SelectField from '../../../forms/SelectField';
import { CLEARING_OPTIONS } from '../../../../constants/settings';

class PerformanceFilters extends Component {
    _setFilterArtists = (f) => this.props.setFilter('artists', f);
    _setFilterLive = (f) => this.props.setFilter('live', f);
    _setFilterNonLinear = (f) => this.props.setFilter('nonLinear', f);
    _setFilterStages = (f) => this.props.setFilter('stages', f);

    render() {
        const { artistOptions, stageOptions } = this.props;

        return (
            <div className="u-margin-top-2 rp-hidden-1200-min">
                <div className="ckp-timetable-list-filters">
                    <div className="ckp-grid-row is-center">
                        <div className="ckp-grid-column no-margin-first">
                            <SelectField
                                onChange={this._setFilterArtists}
                                items={artistOptions}
                                label="Artist"
                                multiple={true}
                                value={this.props.artistsFilters}
                            />
                        </div>
                        <div className="ckp-grid-column">
                            <SelectField
                                onChange={this._setFilterStages}
                                items={stageOptions}
                                label="Stage"
                                multiple={true}
                                value={this.props.stagesFilters}
                            />
                        </div>
                        <div className="ckp-grid-column">
                            <SelectField
                                onChange={this._setFilterLive}
                                items={CLEARING_OPTIONS}
                                label="Live Status"
                                multiple={true}
                                value={this.props.liveFilters}
                            />
                        </div>
                        <div className="ckp-grid-column">
                            <SelectField
                                onChange={this._setFilterNonLinear}
                                items={CLEARING_OPTIONS}
                                label="Non Linear Status"
                                multiple={true}
                                value={this.props.nonLinearFilters}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PerformanceFilters;



// WEBPACK FOOTER //
// ./src/components/application/timetable/filter/PerformanceFilters.js